module.exports = __webpack_public_path__ + "img/renwu@3x.a8499ef2.png";